import { useCallback, useMemo } from 'react';

import { ReportTypeKeys } from '@/modules/Reports/report.types';
import { useMultipleEmployerIdsFeatureFlag } from '@/modules/Reports/ReportDetails/hooks';

import { MULTIPLE_EMPLOYERS_REPORT_TYPES } from '../../ScheduledReport.types';

const useIsMultipleEmployerScheduledReport = (reportType?: ReportTypeKeys) => {
  const isEnabled = useMultipleEmployerIdsFeatureFlag();
  const isMultiple = useMemo(() => {
    if (reportType) {
      return MULTIPLE_EMPLOYERS_REPORT_TYPES.includes(reportType);
    }
    return false;
  }, [reportType]);
  const checkIsMultipleEmployerMode = useCallback((reportType: ReportTypeKeys) => {
    return MULTIPLE_EMPLOYERS_REPORT_TYPES.includes(reportType);
  }, []);
  return {
    isMultipleEmployersMode: isEnabled && isMultiple,
    checkIsMultipleEmployerMode,
  };
};
export default useIsMultipleEmployerScheduledReport;
